export default __webpack_public_path__ + "static/11-428ac2da3b9753a9203d020a42482fda.jpg";